<template>
  <div class='sl-img'>
    <div class="sl-img-wrap" @click="handlePreview" :style="{width:this.width , height:this.height}">
      <img class="sl-img" v-show="!loading && src" v-if="type == 'img'" :src="url" @load="handleLoad" />
      <div v-else @click="handlePreview" :style="{background:'url('+url+') #eeeeee center center no-repeat',backgroundSize:backgroundSize , width: this.width , height:this.height}"></div>
      <Spin v-if="loading"></Spin>
      <slot></slot>
    </div>
    <Modal title="预览" :draggable="true" @on-visible-change="handleModelToggle" v-model="visible" :footer-hide="true" class="sl-modal n-padding">
      <div ref="imgwrap" :style="imgWrapStyle">
        <img :src="url" style="width: 100%" :style="{display:extra ? 'none' : 'block'}" >
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import { getStaticPath } from '@/util/request'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
  name: 'Img',
  props: {

    base: {
      default: ''
    },

    src: {
      default: ''
    },
    mode: {
      default: 'default'
    },
    imageUrl:{
      default: 'image'
    },
    previewable: {
      type: Boolean,
      default: true
    },
    backgroundSize: {
      default: 'contain'
    },
    id: {
      type: String,
      default: 'id'
    },

    width: {
      type: [Number, String],
      default: '100%'
    },

    height: {
      type: [Number, String],
      default: '100%'
    },

    type: {
      type: String,
      default: 'img'
    },

    public: {
      type: Boolean,
      default: false
    },

    method: {
      type: [String, Number],
      default: 0
    },
    extra:{
      type:Boolean,
      default:false
    },
  },

  data() {
    return {
      url: '',
      baseURL: '',
      visible: false,
      loading: false,
      viewer:null
    }
  },

  watch: {
    src(val) {
      if (val) {
        this.load(val)
      }else{
        this.url = ''
      }
    }
  },

  computed:{
    imgWrapStyle(){
      if(this.extra){
        return { 'height':'70vh' , 'background':'#000'}
      }else{
       return { }
      }
    }
  },

  created() {
    if (this.src) {
      this.load(this.src)
    }
  },
  beforeDestroy(){
    if( this.viewer ){
      console.log('beforeDestroy')
      this.viewer.destroy()
      this.viewer = null
    }
  },

  methods: {
    handleModelToggle(flag){
      if(!flag){
        this.dispose()
      }
    },
    dispose(){
      if( this.viewer ){
        if( this.extra ){
          this.viewer.destroy()
          this.viewer = null
        }
      }
    },

    load(val) {
      if (val) {
        this.loading = true

        if (this.public) {
          this.loading = false
          this.url = getStaticPath(val)
        } else {
          this.$request[this.imageUrl || 'image'](val, this.method).then(resp => {
            let { data } = resp
            this.loading = false

            if (this.type == 'img') {
              this.loadByObjectURL(data)
            } else {
              this.loadByFileReader(data)
            }
          })
        }
      }

    },

    loadByFileReader(data) {
      let fr = new FileReader()
      fr.readAsDataURL(data)
      fr.onload = (e) => {
        this.url = e.target.result
      }
    },

    //效率更高 但是要手工释放
    loadByObjectURL(data) {
      this.url = window.URL.createObjectURL(data)
    },

    handleLoad() {
      window.URL.revokeObjectURL(this.url)
    },

    handleRotateImage(){
      this.rotation = this.rotation + 1
    },
    handlePreview() {
      if (this.previewable) {
        if( this.extra ){
          let viewer = this.viewer
          if( !viewer ){
            //console.log(  this.$refs['here'] )
            viewer  = new Viewer(this.$refs['imgwrap'], {
              inline:true,
              backdrop:false,
              title:false,
              navbar:false,
              toolbar:{
                zoomIn: 1,
                zoomOut: 1,
                reset: 1,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1
              },
              fullscreen:false,
              className:'sl-img-view',
              // container:this.$refs['here'],
              viewed() {
                viewer.zoomTo(1);
              },
            });

            this.viewer = viewer
            viewer.show()
          }
        }else{
          // this.$dialog({
          //   render: (h) => {
          //     return h('img', {
          //       style: {
          //         maxWidth: '100%',
          //         maxHeight: '100%'
          //       },
          //       attrs: {
          //         src: this.url
          //       }
          //     })
          //   }
          // })
        }

        this.visible = true
        /*
        
        */
      }
    }
  }
}

</script>
<style lang='scss'>
.sl-img .sl-img-wrap {
  text-align: center;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}

.sl-img-view{
  background:#000;
}

</style>
